import React, { useEffect, useState } from "react";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import Input from "../../components/input";
import FIlterSelect from "../../components/filter-select";
import {
  formatCurrency,
  getStatusColor,
  getStatusTextColor,
} from "../../utilz/function";

interface PurchaseRequisition {
  urgencyLevel: string;
  regionName: {
    regionName: string;
  };
}

interface OrderItem {
  _id: {
    _id: string;
    name: string;
  };
  name: string;
  quantity: number;
  unitPrice: number;
  subTotal: number;
  variants: any[];
}

interface OrderData {
  _id: string;
  orderId: string;
  poId: string;
  source: string;
  status: string;
  totalCost: number;
  paymentStatus: string;
  purchaseRequisition: PurchaseRequisition;
  Items: OrderItem[];
  createdAt: string;
}

interface UserTableProps {
  data: OrderData[];
  selectedStatus?: string;
  handleStatusChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

const PurchaseTable: React.FC<UserTableProps> = ({ data, selectedStatus }) => {
  const navigate = useNavigate();
  const [filteredData, setFilteredData] = useState<OrderData[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedType, setSelectedType] = useState("");

  const columns = [
    { header: "Purchase Order", accessor: "poId" },
    { header: "Sourcing Region", accessor: "regionName" },
    { header: "Items", accessor: "items" },
    { header: "Total", accessor: "totalCost" },
    { header: "Order Date", accessor: "createdAt" },
    { header: "Status", accessor: "status" },
    { header: "Urgency", accessor: "urgencyLevel" },
    { header: "Actions", accessor: "_id" },
  ];

  const handleUserClick = (_id: string) => {
    navigate(`/dashboard/purchase/${_id}`);
  };

  useEffect(() => {
    const filtered = data?.filter((order) => {
      const statusMatch = !selectedStatus || order?.status === selectedStatus;

      const searchMatch =
        !searchQuery ||
        order?.purchaseRequisition?.regionName?.regionName
          ?.toLowerCase()
          .includes(searchQuery?.toLowerCase());
      const orderMatch = !selectedType || order?.status === selectedType;

      return statusMatch && searchMatch && orderMatch;
    });
    setFilteredData(filtered);
  }, [data, selectedStatus, searchQuery, selectedType]);

  const combinedData = filteredData?.map((order) => ({
    ...order,

    status: (
      <div>
        <span
          style={{
            color: getStatusTextColor(order?.status),
            backgroundColor: getStatusColor(order?.status),
          }}
          className="p-2 capitalize"
        >
          {order?.status || "N/A"}
        </span>
      </div>
    ),

    totalCost: (
      <div>
        <div>{formatCurrency(order?.totalCost, "NGN", "symbol") || "N/A"}</div>
      </div>
    ),
    
    items: (
      <div className="text-center font-medium">
        {order?.Items?.length || 0}
      </div>
    ),
    
    urgencyLevel: (
      <div className="capitalize">
        {order?.purchaseRequisition?.urgencyLevel || "N/A"}
      </div>
    ),
    regionName: (
      <div className="capitalize">
        {order?.purchaseRequisition?.regionName?.regionName || "N/A"}
      </div>
    ),

  }));

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleOrderFilterChange = (selectedValue: string) => {
    setSelectedType(selectedValue);
  };

  return (
    <div className="py-3 bg-white rounded-3xl shadow border border-[#C9C9C9] mt-10 pt-5">
      <div className="md:flex justify-between px-5">
        <h2 className="text-[20px] font-bold">Purchase Orders</h2>

        <div className="md:flex gap-2 items-center md:mt-0 mt-2">
          <Input
            name="search"
            value={searchQuery}
            onChange={handleSearchChange}
            className="w-full"
            placeholder="Search"
            icon="searchIcon"
          />
          <FIlterSelect
            name="filter"
            options={[
              { label: "All", value: "" },
              { label: "Pending", value: "pending" },
              { label: "Approved", value: "approved" },
              { label: "Cancelled", value: "cancelled" },
            ]}
            value={selectedType}
            onChange={handleOrderFilterChange}
            className="mt-2 md:-mt-2 w-full md:w-[50%]"
            icon="filterIcon"
          />
        </div>
      </div>

      {combinedData?.length > 0 ? (
        <Table
          columns={columns}
          data={combinedData}
          selectedUserId={null}
          onUserClick={handleUserClick}
        />
      ) : (
        <div className="opacity-80 mt-10 font-bold text-center mx-auto">
          No Order found
        </div>
      )}
    </div>
  );
};

export default PurchaseTable;